import React from 'react';

import styles from './SolarSystem.scss';

export default function SolarSystem() {
  return (
    <div className={styles.root}>
      <div className={styles.axisOne}>
        <div className={styles.saturn} />
        <div className={styles.jupiter} />
      </div>
      <div className={styles.axisTwo}>
        <div className={styles.circleOne} />
        <div className={styles.circleTwo} />
      </div>
      <div className={styles.axisThree} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/containers/Mission/components/SolarSystem/SolarSystem.jsx